// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5mGz7","col":"styles_col__12WmL"};